import { useEffect } from 'react';
import { useLoadChargeRoute } from '@src/hooks/queries/account';
import { PaymentMethodsI } from '../../types';

interface Props {
  senderInitials: string;
  handlePaymentMethods: (paymentMethodData: PaymentMethodsI[]) => void;
}

const GetPaymentMethods = ({ senderInitials, handlePaymentMethods }: Props) => {
  const { data } = useLoadChargeRoute({
    country: senderInitials
  });

  useEffect(() => {
    if (data) {
      const res = data?.Data;

      handlePaymentMethods(res as PaymentMethodsI[]);
    }
  }, [data]);

  return null;
};

export default GetPaymentMethods;
